export default [
    {
        path: '/groupShare',
        name: 'groupShare',
        component: () => import('@/views/groupShare'),
    },
    {
        path: '/loadPage',
        name: 'loadPage',
        component: () => import('@/views/loadPage'),
    }
]
